import axios from 'axios'

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

let redirectingToLogin = false

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const externalAuthError = error.response?.headers?.['x-external-auth-error']
      if (externalAuthError) {
        return Promise.reject(error)
      }

      const path = window.location.pathname
      if (!redirectingToLogin && path !== '/login') {
        redirectingToLogin = true
        const next = `${path}${window.location.search}`
        window.location.href = `/login?next=${encodeURIComponent(next)}`
      }
    }
    return Promise.reject(error)
  },
)

export default api
